import { Component } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  AlertController,
  LoadingController,
} from "ionic-angular";
import { AngularFire, FirebaseListObservable } from "angularfire2";

import meanBy from "lodash/meanBy";

@Component({
  selector: "page-user",
  templateUrl: "user.html",
})
export class User {
  // Loader
  loader: any = null;

  // Data
  userModel: any;
  relationship: any = [];
  emotions: any = [];
  health: any = [];
  genders: FirebaseListObservable<any[]>;
  usertypes: FirebaseListObservable<any[]>;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public af: AngularFire,
  ) {
    this.userModel = JSON.parse(JSON.stringify(navParams.get("user")));

    if (this.userModel && this.userModel.relationship) {
      for (var key in this.userModel.relationship) {
        this.relationship.push({
          title: key,
          value: this.userModel.relationship[key],
        });
      }
    }

    if (this.userModel && this.userModel.emotions) {
      this.af.database.list(`/emotions`).subscribe(data => {
        this.emotions = [];
        data.map(item => {
          for (var key in this.userModel.emotions) {
            if (item.title_en.toLowerCase().includes(key)) {
              this.emotions.push({
                title: key,
                value: this.userModel.emotions[key],
                color: item.color,
              });
            }
          }
        });
      });
    }

    // Health
    let healthObs: FirebaseListObservable<any[]> = this.af.database
      .list(`health`)
      .map((array: any) => array.reverse()) as FirebaseListObservable<any[]>;
    healthObs.subscribe((data: any) => {
      this.health = data;
    });

    this.af.database
      .list(`content/${this.userModel.id}`)
      .subscribe((data: any) => {
        let tmpArr: any = [];
        data.map((item: any) => {
          tmpArr.push({ n: parseInt(item.health.level) });
        });
        this.userModel.severity = Math.ceil(meanBy(tmpArr, "n")).toString();
      });

    this.usertypes = this.af.database.list("/usertypes");
    this.genders = this.af.database.list("/genders");
  }

  ionViewDidLoad() {}

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  dismiss() {
    this.dismissLoader();

    setTimeout(() => {
      this.viewCtrl.dismiss();
    }, 400);
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: "Saving...",
      dismissOnPageChange: true,
    });
    this.loader.present();
  }

  validateEmail(email: string) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validFields() {
    try {
      for (var key in this.userModel) {
        console.log(
          "validFields - data",
          key,
          this.userModel[key],
          typeof this.userModel[key],
        );

        if (
          key !== "timestamp" &&
          key !== "id" &&
          key !== "$key" &&
          key !== "$exists" &&
          typeof this.userModel[key] !== "boolean" &&
          typeof this.userModel[key] !== "object" &&
          !(this.userModel[key] instanceof Array)
        ) {
          if (
            this.userModel[key] === null ||
            this.userModel[key].trim() == null ||
            this.userModel[key].trim() == "" ||
            this.userModel[key] === " " ||
            this.userModel[key] === "  "
          ) {
            return false;
          }
        }
      }
      return true;
    } catch (err) {
      console.log("User - validFields", err);
    }
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  onClose() {
    this.dismiss();
  }

  setUsertype(event: any) {
    console.log("setUsertype", event, this.userModel.usertype);
  }

  activateUser() {
    this.userModel.state = "active";
    this.saveUser();
  }

  blockUser() {
    this.userModel.state = "blocked";
    this.saveUser();
  }

  saveUser() {
    try {
      console.log("saveUser", this.userModel);
      this.presentLoading();

      if (!this.validateEmail(this.userModel.email)) {
        this.showMsg("Email is not valid.");
        return;
      }

      if (!this.validFields()) {
        this.showMsg("Please, fill the form correctly.");
        return;
      }

      delete this.userModel.severity;
      delete this.userModel.$key;
      delete this.userModel.$exists;
      this.af.database
        .object(`/users/${this.userModel.id}`)
        .update(this.userModel);

      this.dismiss();
    } catch (error) {
      console.log("saveUser", error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/user/user.ts